import React from "react";
import food1 from "./Image/pexels-dana-tentis-118658-262959.jpg";

function TopImages() {
  return (
    <div className="max-w-[1640px] p-4 py-12 grid  md:grid-cols-3 gap-6 ">
      {/* card */}
      <div className="group rounded-xl relative">
        {/* Overlay */}
        <div className="block absolute h-full w-full bg-black/40 rounded-xl text-white">
          <p className="pt-4 text-2xl font-bold mx-2">Sun's Out,BOGO's Out</p>
          <p className="mx-2">Through 8/26</p>
        </div>
        <button className="absolute text-black bg-white rounded-md bottom-4 py-1 mx-2 font-semibold">
          <span className="m-2">Order Now</span>
        </button>
        <img
          className="object-cover max-h-[160px] md:max-h-[200px] w-full rounded-xl"
          src={food1}
          alt="/"
        />
      </div>
      {/* card */}
      <div className=" rounded-xl relative">
        {/* Overlay */}
        <div className="absolute h-full w-full bg-black/40 rounded-xl text-white">
          <p className="pt-4 text-2xl font-bold mx-2">New Restaurant</p>
          <p className="mx-2">Added Daily</p>
        </div>
        <button className="absolute text-black bg-white rounded-md bottom-4 py-1 mx-2 font-semibold">
          <span className="m-2">Order Now</span>
        </button>
        <img
          className="object-cover max-h-[160px] md:max-h-[200px] w-full rounded-xl"
          src="https://images.pexels.com/photos/1211887/pexels-photo-1211887.jpeg?auto=compress&cs=tinysrgb&w=600"
          alt="/"
        />
      </div>
      {/* card */}
      <div className=" rounded-xl relative">
        {/* Overlay */}
        <div className="absolute h-full w-full bg-black/40 rounded-xl text-white">
          <p className="pt-4 text-2xl font-bold mx-2">We Deliver Desserts</p>
          <p className="mx-2">Tasty Treats</p>
        </div>
        <button className="absolute text-black bg-white rounded-md bottom-4 py-1 mx-2 font-semibold">
          <span className="m-2">Order Now</span>
        </button>
        <img
          className="object-cover max-h-[160px] md:max-h-[200px] w-full rounded-xl"
          src="https://images.pexels.com/photos/1603901/pexels-photo-1603901.jpeg?auto=compress&cs=tinysrgb&w=600"
          alt="/"
        />
      </div>
    </div>
  );
}

export default TopImages;
